import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../shared/auth/auth-guard.service';
import { UserComponent } from './user.component';



const routes: Routes = [
  {
    path: '',
     component: UserComponent,
    data: {
      title: 'User'
    },    
    canActivate: [AuthGuard] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule { }